export default {
    NAME: "Название",
    SUMMARY_REPORTS: "ДОКУМЕНТЫ СВОДКИ",
    CANCEL: "Отмена",
    ADD: "Добавить",
    NO_AVAILABLE_SUMMARY_REPORTS: "Нет доступных вариантов",
    SELECT_ALL: "Выбрать все"
};
